




































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import { IDossierCounter } from '../../../store/models/IDossierCounter';
import IInbound from '@/store/models/IInbound';

@Component({
    components: { Snackbar }
})
export default class DossierCounter extends Vue {
  @Prop({ type: Array, required: true }) Permissions!: IRolePermission[];
  @Prop({ type: Array, required: true }) Counters!: IDossierCounter[];
  @Prop({ type: Array, required: true }) InboundList!: IInbound[];

  inboundSelected: any = '';

  get inboundItems(): string[] {
      const inboundsCode = this.InboundList.map(t => t.code);
      const inboundsCodeDestination = this.InboundList.map(t => t.codeDestination);
      return inboundsCode.concat(inboundsCodeDestination);
  }

  get hasInboundSelected(): boolean {
      // Muestra Print Dossier solo si hay algo seleccionado
      return !!this.inboundSelected && this.inboundSelected !== '';
  }

  @Watch('inboundSelected')
  onChangeInbound() {
      this.$emit('onChangeInbound', this.inboundSelected);
  }

  formatType(type: string): string {
      return type.replace(/([A-Z])/g, ' $1').trim();
  }

  getIcon(type: string): string {
      const iconMap: { [key: string]: string } = {
          Goods: 'fa-shopping-basket',
          GoodsMovements: 'fa-exchange',
          InboundsDeliveryNotes: 'fa-sticky-note-o',
          InboundsDocuments: 'fa-file-text',
          InboundsNoticeOfLoss: 'fa-sticky-note-o',
          InboundsPictures: 'fa-camera',
          Outbounds: 'fa-arrow-circle-up',
          OutboundsDocuments: 'fa-file-text',
          OutboundsNoticeOfLoss: 'fa-sticky-note-o',
          OutboundsPictures: 'fa-camera',
          PrintDossier: 'fa-print'
      };
      return iconMap[type] || 'fa-folder';
  }

  onItemClick(type: string) {
      this.$emit('onSelectType', type);
  }
}
